import {List, ListItem, ListItemButton, ListItemText} from '@mui/material';
import type {IssueCreateResponse} from '@/Hooks/useCreateIssue.ts';

type Props = {
    issues: IssueCreateResponse[];
    offBoarding?: boolean;
};
const DisplayIssues = ({issues, offBoarding}: Props) => {
    return (
        <List>
            {issues.map(i => {
                return (
                    <ListItem disablePadding key={`issue-item-${i.id}`}>
                        <ListItemButton
                            component='a'
                            href={`https://soliant${offBoarding ? '-offboarding' : ''}.atlassian.net/browse/${i.key}`}
                            target='_blank'
                        >
                            <ListItemText primary={i.key} />
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>
    );
};

export default DisplayIssues;
